import { useReveal } from "@/hooks/useReveal";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import FeaturedRoast from "@/pages/home/components/FeaturedRoast";
import OriginStory from "@/pages/home/components/OriginStory";
import CoreOfferings from "@/pages/home/components/CoreOfferings";
import About from "@/pages/home/components/About";
import Coffee from "@/pages/home/components/Coffee";
import Visit from "@/pages/home/components/Visit";
import Editorial from "@/pages/home/components/Editorial";
import Invitation from "@/pages/home/components/Invitation";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  useReveal();

  return (
    <main className="w-full min-w-[1024px] bg-background-50 text-foreground-950">
      <Navbar />
      <Hero />
      <FeaturedRoast />
      <OriginStory />
      <CoreOfferings />
      <About />
      <Coffee />
      <Visit />
      <Editorial />
      <Invitation />
      <Footer />
    </main>
  );
}